import {
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  IconButton,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { FaTimes } from "react-icons/fa";

type DrawerWrapper = {
  onOpen?: () => void;
  onClose: () => void;
  isOpen: boolean;
  children: ReactNode;
  title?: string;
  size?: string;
  placement?: any;
};

const DrawerWrapper = (props: DrawerWrapper) => {
  const { isOpen, onClose, title, size = "lg", placement } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Drawer
      onClose={onClose}
      isOpen={isOpen}
      size={isLargerThan900 ? size : "full"}
      placement={placement}
    >
      <DrawerOverlay />
      <DrawerContent overflowY="scroll">
        <Flex justifyContent={"space-between"} alignItems="center" p="3">
          <Text fontWeight={"bold"} fontSize="lg">
            {title}
          </Text>
          <IconButton
            aria-label="Close Buton"
            onClick={onClose}
            icon={<FaTimes />}
          />
        </Flex>
        {props.children}
      </DrawerContent>
    </Drawer>
  );
};

export default DrawerWrapper;
